<template>
  <div class="content">
    <div class="content_top">
      <h3 class="content_title">
        {{ title }}：
      </h3>
      <a-button @click="toEdit">
        {{ $t('message["36"]') }}
      </a-button>
    </div>
    <div
      class="content_main"
    >
      <div
        v-if="fields.length > 0"
        class="main_item"
      >
        <a-tag
          v-for="item in fields"
          :key="item.id || item.fieldkey"
        >
          {{ item.fieldname }}
        </a-tag>
      </div>
      <div
        v-else
        class="main_item"
      >
        <span v-text="untext" />
      </div>
    </div>
    <!-- <a-spin v-else /> -->
  </div>
</template>

<script type="text/ecmascript-6">
import i18n from '@/lib/language'
// import { mapState } from 'vuex'
export default {
  props: {
    title: {
      type: String,
      default: i18n.t('message["646"]')
    },
    fields: {
      type: Array,
      default: () => []
    },
    untext: {
      type: String,
      default: i18n.t('message["1556"]')
    }
  },
  computed: {
    // ...mapState('config/repeat', ['dataIsReady'])
  },
  methods: {
    toEdit () {
      this.$emit('edit')
    }
  }
}
</script>

<style scoped lang="scss">
.content {
  margin-top: 12px;
  .content_title {
    display: inline-block;
    width: 130px;
    font-size: 14px;
    margin-right: 24px;
    color: rgba(102, 102, 102, 1);
    text-align: right
  }
  .content_main {
    margin-top: 20px;
    .main_item {
      width: 700px;
      margin-left: 155px;
      color: rgba(179, 179, 179, 1);
      .ant-tag {
        margin-bottom: 12px
      }
    }
  }
}
</style>
